import Vue from 'vue'
import Header from './Header'
import Item from './Item'

Vue.component('w-lab-header', Header)
Vue.component('w-lab-item', Item)
